import axios from "axios";



export const getUsdBalance = async (chain, address) => {
    try {
      const response = await axios.get(
        "https://min-api.cryptocompare.com/data/pricemulti?fsyms=ETH,BNB&tsyms=,USD,&api_key=e43d5fefb19663596b7056614ae812b66596bee3ee82689c5e97cdfa322a28c4",
        
      ).then(async(_res)=>{
          
          let USDprices = [];

          USDprices.push({
              EthUsd: _res.data.ETH.USD,
              BnbUsd:_res.data.BNB.USD
          });

          return USDprices;
      });
      return response;
      
      
   
    } catch (error) {
      console.error("Error retrieving balance:", error.message);
      return 0; // or return any other default value you want to use
    }
  };
  